var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.174 21.115c.276-.846 1.57-9.283 1.73-10.945.048-.503-.111-.837-.423-.986-.378-.182-.938-.091-1.588.142-.891.321-12.29 5.164-12.948 5.445-.624.265-1.214.554-1.214.971 0 .293.175.458.656.63.501.179 1.764.562 2.509.768.721.199 1.542.026 2.002-.261.487-.303 6.093-4.056 6.497-4.387.404-.331.726.093.395.424-.331.331-4.18 4.066-4.687 4.583-.615.627-.178 1.278.234 1.538.47.296 3.866 2.574 4.378 2.94.512.366 1.031.532 1.507.532.476 0 .726-.625.952-1.394z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramQr);
export default __webpack_public_path__ + "static/media/telegramQR.312e252ae8506c977c0225c341960d8f.svg";
export { ForwardRef as ReactComponent };